export const aliasesConfig = {
  maindocs_51: {
    docId: 'HP160044',
    module: 'lawmaking'
  },
  cases_for_business_access: {
    docId: 'HP160041',
    module: 'situationBusiness'
  },
  novation_map_access: {
    docId: 'HP160046',
    module: 'mapNews'
  },
  business_safety_ceo_access: {
    docId: 'HP160051',
    module: 'securityBusiness'
  },
  ukraine_goverment_access: {
    docId: 'HP160049',
    module: 'authorityUa'
  },
  draft_laws_access: {
    docId: 'HP160034',
    module: 'lawProject'
  },
  'contracts&templates_access': {
    docId: 'HP160047',
    module: 'patterns'
  },
  advice_for_accountant_access: {
    docId: 'HP160029',
    module: 'consultations'
  },
  news_biz: {
    docId: 'HP160045',
    module: 'lawPictures'
  },
  glossary_access: {
    docId: 'HP160039',
    module: 'termVocabulary'
  },
  bankrupcy_access: {
    docId: 'HP160048',
    module: 'bankruptcy'
  },
  cases_for_accountant_access: {
    docId: 'HP160027',
    module: 'situationAccountant'
  },
  calendar_accountant_access: {
    docId: 'HP160030',
    module: 'calendarAccountant'
  },
  taxation_knowlege_base_access: {
    docId: 'HP160031',
    module: 'taxBase'
  },
  cases_for_lawyer_access: {
    docId: 'HP160033',
    module: 'situationLawyer'
  },
  calendar_law_access: {
    docId: 'HP160040',
    module: 'calendarLawyer'
  },
  judicial_practice_access: {
    docId: 'HP160035',
    module: 'courtPractice'
  },
  commented_codexes_access: {
    docId: 'HP160037',
    module: 'commentsCodex'
  },
  european_legislation_access: {
    docId: 'HP160038',
    module: 'europeanLegislation'
  },
  'forms&blanks_access': {
    docId: 'HP160028',
    module: 'forms'
  },
  industry_access: {
    docId: 'HP170001',
    module: 'industry'
  },
  accountant_and_law_access: {
    docId: 'HP170004',
    module: 'accountant_and_law'
  },
  business_schema_access: {
    docId: 'HP170003',
    module: 'business_schema'
  },
  cases_for_hr_access: {
    docId: 'HP160042',
    module: 'cases_for_hr'
  },
  judicial_practice_for_acountant_access: {
    docId: 'HP160032',
    module: 'judicial_practice_for_acountant'
  },
  calculator_vc_access: {
    docId: 'HP160024',
    module: 'calculator_vc'
  },
  calculator_zp_access: {
    docId: 'HP160023',
    module: 'calculator_zp'
  },
  instructions_access: {
    docId: 'HP160043',
    module: 'instructions'
  },
  directories_access: {
    docId: 'HP160052',
    module: 'directories'
  },
  pravo_access: {
    docId: 'HP160014',
    module: 'pravo'
  },
  fulltext_search_access: {
    docId: 'HP160014',
    module: 'search'
  },
  accounting_entries_access: {
    docId: 'HP160055',
    module: 'wiring'
  },
  calculator_ff_access: {
    docId: 'HP160053',
    module: 'fines_calc'
  },
  precedents_access: {
    docId: 'HP160036',
    module: 'juridical_precedents'
  },
  b_mini: {
    docId: 'HP160057',
    module: 'situationAccountant_b_mini'
  },
  uz_web: {
    docId: 'HP160058',
    module: 'uz_web'
  },
  bz_web: {
    docId: 'HP160059',
    module: 'bz_web'
  },
  fz_web: {
    docId: 'HP160060',
    module: 'fz_web'
  },
  contractor: {
    docId: 'HP160065',
    module: 'contractor'
  },
  verdictum_web: {
    docId: 'HP160063',
    module: 'verdictum_web'
  },
  ib: {
    docId: 'HP160061',
    module: 'ib'
  },
  expert: {
    docId: 'HP170015',
    module: 'personalExpert'
  },
  smsmayak: {
    docId: 'HP160064',
    module: 'smsmayak'
  },
  smsmayak_earth: {
    docId: 'HP180003',
    module: 'smsmayak_earth'
  },
  semantrum_web: {
    docId: 'HP180002',
    module: 'semantrum_web'
  },
  ips_reporting: {
    docId: 'HP170002',
    module: 'ips_reporting'
  },
  demo: {
    docId: 'HP170012',
    module: 'demo'
  },
  grand_excess: {
    docId: 'HP170007',
    module: 'grand_excess'
  },
  configprime_lpr: {
    docId: 'HP170008',
    module: 'configprime_lpr'
  },
  config_standart: {
    docId: 'HP170009',
    module: 'config_standart'
  },
  lawyer_profi: {
    docId: 'HP170010',
    module: 'lawyer_profi'
  },
  lawyer: {
    docId: 'HP170011',
    module: 'lawyer'
  }
};
